import { ModalType, SensitiveData } from '@philips-internal/oswald-ui-constants';
import { arrayOf, bool, element, eventListener, expression, fragment, object, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
const LocatorProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    className: {
        type: string,
    },
    contextData: {
        type: object.notEnumerable(),
    },
    data: {
        defaultValue: [],
        type: arrayOf(object).notEnumerable(),
    },
    displayProp: {
        defaultValue: '',
        type: string,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    fragment: {
        type: fragment,
    },
    inputEnabled: {
        defaultValue: true,
        type: bool,
    },
    loading: {
        defaultValue: false,
        type: bool.notEnumerable(),
    },
    modalType: {
        defaultValue: ModalType.DEFAULT,
        type: oneOf(enumValues(ModalType)),
    },
    onBlur: {
        type: eventListener,
    },
    onChange: {
        type: eventListener,
    },
    onFocus: {
        type: eventListener,
    },
    onNextPage: {
        type: eventListener,
    },
    placeholder: {
        defaultValue: 'Sample label',
        type: expression,
    },
    readOnly: {
        type: bool.notEnumerable(),
    },
    sensitiveData: {
        defaultValue: SensitiveData.NONE,
        type: oneOf(enumValues(SensitiveData)),
    },
    strikethrough: {
        type: bool,
    },
    valid: {
        defaultValue: true,
        type: bool.notEnumerable(),
    },
    value: {
        type: object.notEnumerable(),
    },
};
export { LocatorProperties, };
//# sourceMappingURL=locator-types.js.map